import React from 'react';
import { CalendarDaysIcon, ChartColumnIcon, ClipboardCheckIcon, GaugeIcon, SearchIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { toolkits } from '../../data/content';
const iconMap = {
  clipboard: ClipboardCheckIcon,
  chart: ChartColumnIcon,
  search: SearchIcon,
  gauge: GaugeIcon,
  calendar: CalendarDaysIcon
};
export function Toolkits() {
  return <section className="bg-cream px-4 py-16 sm:py-20" aria-labelledby="toolkits-title" data-id="element-236" data-mp="450xvqv2jy6e">
      <div className="mx-auto max-w-4xl" data-id="element-237" data-mp="479yxhmmjdi">
        <h2 id="toolkits-title" className="text-center font-serif text-[30px] font-black leading-tight text-ink sm:text-5xl" data-id="element-238" data-mp="35wkmd51ksm">
          You’ll also get immediate access to
        </h2>
        <ul className="mt-10 divide-y divide-ink/10 rounded-3xl bg-white px-5 sm:px-8" data-id="element-239" data-mp="8xanf5s9uw85">
          {toolkits.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 py-5" data-id="element-240" data-mp="iv89pnqkmiy4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gold" data-id="element-241" data-mp="ism4vvv2ehjl">
                  <Icon className="h-6 w-6 text-ink" aria-hidden="true" data-id="element-242" data-mp="9cnev7fvr662" />
                </span>
                <div data-id="element-243" data-mp="de8moedk4u9e">
                  <h3 className="text-lg font-extrabold text-ink" data-id="element-244" data-mp="ddqp9ef5s9zw">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink/75" data-id="element-245" data-mp="idbo7oubwicm">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>
        <p className="mx-auto mt-8 max-w-2xl text-center text-[17px] font-medium leading-relaxed text-ink" data-id="element-246" data-mp="nc6aj0ri8p1h">
          When a recurring picking problem shows up in your operation, you’ll have a structured process to diagnose it,
          measure it and decide what to do next.
        </p>
        <SectionCta label="Get access to the complete system" data-id="element-247" data-mp="113beug5ti5i5" />
      </div>
    </section>;
}